/**
 * Module dependencies.
 */

import React from 'react';
import { Checkbox } from 'antd';
import { LiveToggle } from '../form-filters-type';

/**
 * `Props` type.
 */

type Props = {
  item: LiveToggle;
  form: any;
  className?: string;
  fieldClassName?: string;
};

/**
 * Export `FilterLiveToggle` component.
 */

export function FilterLiveToggle({ item, form, className, fieldClassName }: Props): JSX.Element {
  const { watch, setValue } = form;
  const value = watch('__liveMode') || false;

  return (
    <div
      className={className}
      style={{ display: 'flex', alignItems: 'flex-end', minHeight: '66px', paddingBottom: '8px' }}
    >
      <div className={fieldClassName}>
        <Checkbox checked={value} onChange={e => setValue('__liveMode', e.target.checked)}>
          {item.label}
        </Checkbox>
      </div>
    </div>
  );
}
